module.exports = __webpack_public_path__ + "static/media/marcus-smart-banner-min.3b947b0f.png";